import { createSelector } from 'reselect'

const getLocalState = state => state.likes

export const isLiked = (state, id) => createSelector(
	getLocalState,
	likes => likes.indexOf(id) !== -1
)(state)
